export default "__VITE_ASSET__olLvKuWt__"